"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var ThxDialogComponent = /** @class */ (function () {
    function ThxDialogComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    ThxDialogComponent.prototype.ngOnInit = function () { };
    ThxDialogComponent.prototype.closeAction = function () {
        this.dialogRef.close();
    };
    return ThxDialogComponent;
}());
exports.ThxDialogComponent = ThxDialogComponent;
